import React, { useState, useEffect } from "react";
import Card from "../Reusablecomponents/Card";
import CropSelector from "../Reusablecomponents/CropSelector";
import ChartView from "./ChartView";
import TableView from "./TableView";
import NestedDropdown from "../Reusablecomponents/NestedDropdown";
import { DataVisualizationApi } from "../api";
import { padding } from "@mui/system";

function DataVisualization({ orgIdOrUuid }) {
    const [cropId, setCropId] = useState();
    const [greenhouse, setGreenhouse] = useState('');
    const [site, setSite] = useState('');
    const [availableParams, setAvailableParams] = useState({});
    const [selectedParams, setSelectedParams] = useState([]);
    const [crop, setCrop] = useState('');

    useEffect(() => {
        if (!cropId) return;

        const fetchParameters = async () => {
            try {
                const response = await DataVisualizationApi.fetchParametersList(cropId);
                const grouped = {};
                Object.entries(response).forEach(([section, keys]) => {
                    grouped[section] = keys.map((key) => ({
                        key: `${section}.${key}`,
                        label: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
                    }));
                });
                setAvailableParams(grouped);
                const defaultKeys = ["climate.temperature", "harvest.harvested_weight", "climate.Light"];

                const defaults = Object.values(grouped)
                    .flat()
                    .filter((item) => defaultKeys.includes(item.key))
                    .map((item) => ({
                        key: item.key,
                        name: item.label
                    }));

                setSelectedParams(defaults);

            } catch (error) {
                console.error("Failed to load parameters list:", error);
            }
        };

        fetchParameters();
    }, [cropId]);

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "left", gap: "20px", padding: "20px", width: "100%" }}>
            <Card header="Data Visualization" style={{ minHeight: "400px", width: "70%", maxWidth: "1200px", }}>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'left', paddingLeft: '0.3rem' }}>
                    <CropSelector
                        setCropId={setCropId}
                        orgIdOrUuid={orgIdOrUuid}
                        onChange={(siteName, greenhouseName, _, cropName) => {
                            setSite(siteName);
                            setGreenhouse(greenhouseName);
                            setCrop(cropName);
                        }}
                    />

                    <NestedDropdown
                        name="Parameters"
                        selectedParams={selectedParams}
                        setSelectedParams={setSelectedParams}
                        maxSelections={3}
                        parameters={availableParams}
                    />
                </div>
                <ChartView selectedParams={selectedParams} cultivationZoneId={cropId} />
            </Card>
            <Card header="Data" style={{ minHeight: "600px", width: "70%", maxWidth: "1200px" }}>
                <TableView cultivationZoneId={cropId} site={site} greenhouse={greenhouse} crop={crop} />
            </Card>
        </div>
    );
}

export default DataVisualization;
